import type { NodeApi } from "@hogartrabe/react-arborist-vrh";
import { isNodeVisibilityClickable } from "utils";
import type { Node } from "interfaces/schemas";
import { computeNodeToggleActiveStatusUpdates } from "./utils";
import type { Project } from "../projectStore";
import { processNodes } from "./utils/mutations";

export const toggleNodeActiveStatus = (
  node: NodeApi<Node>,
  tree: Node[],
  project: Project,
  language: string,
) => {
  if (!isNodeVisibilityClickable(node.data)) {
    return tree;
  }

  if (!project?.id) {
    throw new Error("Project ID is missing. Cannot toggle node active status.");
  }

  const newStatus = !node.data.active;
  const nodesToUpdate = computeNodeToggleActiveStatusUpdates(
    node,
    newStatus,
    project.id,
  );

  processNodes(
    [
      {
        nodes: nodesToUpdate,
        action: "UPDATE",
      },
    ],
    project,
    language,
  );
  // Return a shallow copy so that React-Arborist knows to rerender.
  return [...tree];
};
